import React from 'react';
import { Bar, PieTabled } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const LeadRankingTableSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createRowFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Bar
                        title={t("Lead by Area")}
                        dataProviderName={'statisticsviews/leadsperarea/aggregated/views_opportunities_lead/_related_area_name'}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box>
                <Box className="report-item">
                    <Bar
                        title={t("Lead by Shop")}
                        dataProviderName={"statisticsviews/leadspershop/aggregated/views_opportunities_lead/_related_shop_name"}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box>
                {/* <Box className="report-item">
                    <Bar
                        title={t("Lead by Agent")}
                        dataProviderName={"statisticsviews/leadsperagent/aggregated/views_opportunities_lead/_related_agent_fullname"}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box> */}

                <Box className="report-item">
                    <Bar
                        title={t("Lead by Source")}
                        dataProviderName={"statisticsviews/leadspersource/aggregated/views_opportunities_lead/_related_source_name"}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box>
            </Box>
            
        </Box>
    )
}

export default LeadRankingTableSet;
